import { render, staticRenderFns } from "./kundenprelogo.vue?vue&type=template&id=3fe4dd82&scoped=true&"
import script from "./kundenprelogo.vue?vue&type=script&lang=js&"
export * from "./kundenprelogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe4dd82",
  null
  
)

export default component.exports